export const __OBJECT_STRUCTURE_GetUserProps = (username = null) => {
    return {
        "hasAccess": false,
        "hasRole": false,
        "onlyObserver": false,
        "bookId": null,
        "bookStatusId": null,
        "partyId": null,
        "partyMemberId": null,
        "roleId": null,
        "l_SectionPartyMemberHandler": [],
        "username": username,
        "isAdmin": false,
        "email": null
    }
}

export const __OBJECT_STRUCTURE_CooperativeAssignament = (username = null) => {
    return {
        "id": null,
        "name": null,
        "description": null,
    }
}